import * as types from 'reducer/actionTypes'
import {isEmpty} from 'script/common';

const initialState = {
	adapterList:[{
		name:null,
		classNames:null,
		state:false,
		author:null,
		description:null,
		level:null
	}],
	
	adapterRegister:{
		modalVisible: false,
		errorLabel:{},
	},

	adapterUpdate:{
		modalVisible: false,
		errorLabel:{},
		data:{},
	},

	adapterSetting:{
		modalVisible: false,
		errorLabel:{},
		data:{},
	},

	error:{}
};

export default function adapter(state = initialState, action){
	switch(action.type){
		// set modal
		case types.SET_ADAPTER_REGISTER_MODAL:
			return {
				...state,
				adapterRegister:{
					...state.adapterRegister,
					modalVisible: !state.adapterRegister.modalVisible,
					errorLabel:initialState.adapterRegister.errorLabel
				}
			}

		case types.SET_ADAPTER_UPDATE_MODAL:
			return {
				...state,
				adapterUpdate:{
					modalVisible: !state.adapterUpdate.modalVisible,
					errorLabel: initialState.adapterUpdate.errorLabel,
					data: isEmpty(action.data) ? initialState.adapterUpdate.data : action.data
				}
			}
		
		case types.SET_ADAPTER_SETTING_MODAL: 
			return {
				...state,
				adapterSetting:{
					modalVisible: !state.adapterSetting.modalVisible,
					errorLabel: initialState.adapterSetting.errorLabel,
					data: initialState.adapterSetting.data
				}
			}

		// set error
		case types.SET_ADAPTER_REGISTER_ERRORLABEL:
			return {
				...state,
				adapterRegister:{
					...state.adapterRegister,
					errorLabel:action.errorLabel
				}
			}

		case types.SET_ADAPTER_SETTING_ERRORLABEL:
			return {
				...state,
				adapterSetting:{
					...state.adapterSetting,
					errorLabel:action.errorLabel
				}
			}

		case types.SET_ADAPTER_UPDATE_ERRORLABEL:
			return {
				...state,
				adapterUpdate:{
					...state.adapterUpdate,
					errorLabel:action.errorLabel
				}
			}
		
		// set value
		case types.SET_ADAPTER_SETTING_STORAGENAME:
			return {
				...state,
				adapterSetting:{
					...state.adapterSetting,
					data:{
						...state.adapterSetting.data,
						storageName: action.storageName
					}
				}
			}

		case types.SET_ADAPTER_SETTING_PARAMSNAME:
			return {
				...state,
				adapterSetting:{
					...state.adapterSetting,
					data:{
						...state.adapterSetting.data,
						paramsName: action.paramsName
					}
				}
			}
		
		case types.SET_ADAPTER_SETTING_ROOTNAME:
			return {
				...state,
				adapterSetting:{
					...state.adapterSetting,
					data:{
						...state.adapterSetting.data,
						rootName: action.rootName
					}
				}
			}

		case types.SET_ADAPTER_SETTING_ROOTPATH:
			return {
				...state,
				adapterSetting:{
					...state.adapterSetting,
					data:{
						...state.adapterSetting.data,
						rootPath: action.rootPath
					}
				}
			}
		
		// fetch success
		case types.FETCH_ADAPTER_ERROR_SUCCESS:
			return {
				...state,
				error: initialState.error
			}

		case types.FETCH_GET_ADAPTER_LIST_SUCCESS:
			return {
				...state,
				adapterList: action.value,
			}
		
		case types.FETCH_GET_ADAPTER_SETTING_SUCCESS:
			return {
				...state,
				adapterSetting:{
					...state.adapterSetting,
					modalVisible: !state.adapterSetting.modalVisible,
					data: {
						adapter: action.value.adapter,
						storageName: action.value.storageName,
						paramsName: action.value.paramsName,
						rootName: action.value.rootName.trim(),
						rootPath:decodeURIComponent(action.value.rootPath.trim())
					}
				},
				error: initialState.error
			}

		// fetch failure
		case types.FETCH_ADAPTER_ERROR_FAILURE:

			return {
				...state,
				error: action.error
			}

		case types.FETCH_GET_ADAPTER_LIST_FAILURE:
			return {
				...state,
				adapterList:initialState.adapterList
			}

		default:
			return state
	}
};